import { BmiMocks } from '@local-mocks';
import { Bmi } from '@types-lib';

export const baseBmiInitialState: Bmi.BaseBmiStoreState = {
  treatmentDetails: BmiMocks.EMPTY_BMI_GET_RESPONSE.data.treatment_details,
  patientUserId: 0,
  bmiListOptions: {
    filterBy: { serviceCodes: [] },
    sort: 'desc',
    pagination: BmiMocks.EMPTY_BMI_GET_RESPONSE.pagination,
  },
  itemBeingEditedId: null,
};

export const bmiItemEntityInitialState: Bmi.BmiItemEntityState = {
  bmiItemEntityMap: {},
  bmiItemIds: [],
  bmiItemEntities: [],
};

export const initialBmiState: Bmi.BmiStoreState = {
  ...baseBmiInitialState,
  ...bmiItemEntityInitialState,
};
